export default __webpack_public_path__ + "static/TypeMates-SombraRegular-e0dfa6dfe871f01caaa354b47ccbda32.otf";